<template>
  <div class="section-hero sectionBackGround">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-2">
          <card class="border-0 text-left" hover shadow body-classes="py-3" style="margin-top: 20px;">
            <div class="row row-cols-2 row-cols-lg-5 g-2 g-lg-3">
              <div class="col-4 col-md-12">
                <label>会员中心</label>
              </div>
              <div class="col-4 col-md-12" style="background-color: #f0f0f0;">
                <a class="nav-link" href="#/PersonalDataList?searchQuery=2"
                  style="height: 35px; background-color: #f0f0f0">
                  <ul style="margin-left: -28px;">
                    <li> <label>个人资料</label></li>
                  </ul>
                </a>
              </div>
              <div class="col-4 col-md-12">
                <a class="nav-link" href="" style="height: 35px; ">
                  <ul style="margin-left: -28px;">
                    <li> <label>我的收藏</label></li>
                  </ul>
                </a>
              </div>
              <div class="col-4 col-md-12">
                <a class="nav-link" href="#" style="height: 35px;">
                  <ul style="margin-left: -28px;">
                    <li> <label>退出登录</label></li>
                  </ul>
                </a>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-10">
          <card style="margin-top: 20px;">
            <hr class="divider" />
            <form>
              <div class="row">
                <div class="col-md-2">
                  <label>用户名</label>
                </div>
                <div class="col-md-3">
                  <label>{{ username }}</label>
			 
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <label>邮箱</label>
                </div>
                <div class="col-md-3">
                  <label>songxl@qq.com</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <label>用户类型</label>
                </div>
                <div class="col-md-3">
                  <label>VIP 用户</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <label>密码</label>
                </div>
                <div class="col-md-3">
                  <label>*******</label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <base-button tag="a" href="#/PersonalDataEdit" type="success" size="lg" block>
                    更改个人资料
                  </base-button>
                </div>
                <div class="col-md-3">
                  <base-button tag="a" href="#/PersonalDataEdit1" type="success" size="lg" block>
                    更改密码
                  </base-button>
                </div>
              </div>
            </form>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "DocQueryList",
  data() {
    return {
      searchQuery: '',
      searchResults: [],
      page: 1,
      username: '',  // 用于显示用户名

      totalDocuments: 0, // 确保初始化
      currentPage: 1,
      itemsPerPage: 10, // 默认每页10条
      loading: false,
      pagination: {
        default: 1
      },
    };
  },
  methods: {
	  getCookie(name) {
	        const value = `; ${document.cookie}`;
	        const parts = value.split(`; ${name}=`);
	        if (parts.length === 2) return parts.pop().split(';').shift();
	      }
	  
	  
  },
  created() {
      this.username = this.getCookie('username');
  },
 
};
</script>

<style scoped>
.sectionBackGround {
  /* 使内容区域填充剩余空间 */
  min-height: calc(100vh - 48px);
  /* 确保内容区域至少与视口高度减去头部高度一样大 */
  background-image: url('https://anthromindxx.com/ant/bj.jpeg');
  /* 设置背景图路径 */
  background-position: center center;
  /* 背景图片位置 */
  background-attachment: fixed;
  /* 背景图片相对于视口固定 */
  background-size: 100% 100%;
  /* 背景图片根据元素大小缩放 */
  overflow-y: auto;
  /* 在内容较多时显示滚动条 */
  overflow: auto;
}

/* 当屏幕尺寸小于某个值时，为元素添加滚动条 */
@media (max-width: 600px) {
  .sectionBackGround {
    height: 300px;
    /* 设置一个固定高度或者最大高度 */
    overflow-y: scroll;
    /* 仅在垂直方向上显示滚动条 */
  }
}

.divider {
  width: 100%;
  height: 1px;
  background-color: #ccc;
  margin-top: 5px;
}
</style>